module.exports = __webpack_public_path__ + "img/thumb_14.72e0d6be.jpg";